import React from 'react';
import PropTypes from 'prop-types';
import css from './CwPodElement.scss';
import cx from 'classnames';

const CwPodElement = (props) => {
  if (props.ghostPodElement) {
    return (
      <div className={css.wrap} />
    );
  }

  return (
    <div className={cx(css.wrap, {
      [css.label]: props.label,
      [css.required]: props.label && props.isRequired,
      [css.labelinvalid]: props.label && props.invalid,
      [css.labelblue]: props.label && props.labelBlue,
    })}>
      {props.label}
      {props.widget}
    </div>
  );
};

CwPodElement.propTypes = {
  labelBlue: PropTypes.bool,
  label: PropTypes.element,
  isRequired: PropTypes.bool,
  invalid: PropTypes.bool,
  widget: PropTypes.element,
  ghostPodElement: PropTypes.bool
};

export default CwPodElement;


// WEBPACK FOOTER //
// ./src/components/cwpod/CwPodElement.jsx